/* Ornamental mandala rings — fine circular lines that draw themselves
   in on load, then rotate almost imperceptibly forever. Pure SVG + CSS. */
export const Mandala = ({ className = "" }) => {
    return (
        <svg
            viewBox="0 0 600 600"
            aria-hidden="true"
            className={`pointer-events-none ${className}`}
        >
            <g className="mandala-spin" style={{ transformBox: "fill-box" }}>
                <circle
                    cx="300" cy="300" r="190"
                    fill="none" stroke="#C8A15A" strokeOpacity="0.35" strokeWidth="0.7"
                    className="mandala-ring" style={{ "--dash": 1200 }}
                />
                <circle
                    cx="300" cy="300" r="228"
                    fill="none" stroke="#C8A15A" strokeOpacity="0.22" strokeWidth="0.6"
                    strokeDasharray="2 9"
                    className="mandala-ring" style={{ "--dash": 1450, animationDelay: "0.5s" }}
                />
                {Array.from({ length: 24 }).map((_, i) => {
                    const a = (i * 15 * Math.PI) / 180;
                    const x1 = 300 + 196 * Math.cos(a);
                    const y1 = 300 + 196 * Math.sin(a);
                    const x2 = 300 + 222 * Math.cos(a);
                    const y2 = 300 + 222 * Math.sin(a);
                    return (
                        <line
                            key={i} x1={x1} y1={y1} x2={x2} y2={y2}
                            stroke="#C8A15A" strokeOpacity="0.16" strokeWidth="0.5"
                        />
                    );
                })}
            </g>
            <g className="mandala-spin--reverse" style={{ transformBox: "fill-box" }}>
                <circle
                    cx="300" cy="300" r="262"
                    fill="none" stroke="#C8A15A" strokeOpacity="0.14" strokeWidth="0.6"
                    strokeDasharray="1 14"
                    className="mandala-ring" style={{ "--dash": 1650, animationDelay: "1s" }}
                />
                <circle
                    cx="300" cy="300" r="150"
                    fill="none" stroke="#A51C30" strokeOpacity="0.3" strokeWidth="0.6"
                    strokeDasharray="4 10"
                    className="mandala-ring" style={{ "--dash": 950, animationDelay: "1.4s" }}
                />
            </g>
        </svg>
    );
};
